export const returnAuthHeader = () => {
  let token = localStorage.getItem("wemoovezdrivertoken");
  return { headers: { Authorization: token } };
};
